import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ImportCashSettingsResultDialogComponent } from '@irb/irb-clients/import-cash-settings-result-dialog/import-cash-settings-result-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportCashSettingsResultGridLayoutService implements GridLayoutService<ImportCashSettingsResultDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Account',            
            field: 'entity',
            maxWidth: 100,
            flex: 1,
            sort:'asc'
        },
        {
            headerName: 'Error Condition',
            field: 'errorDesc',
            maxWidth: 371,
            flex: 3
        },
        {
            headerName: 'Line Number',
            field: 'lineNumber',
            maxWidth: 120,
            flex: 1
        }];
    }
}
